import { once } from 'lodash-es'

export function useAvailability(load, product) {
  const loading = ref(false)
  const success = ref(null)
  const availabilities = ref([])
  const parentPrice = ref(null)
  const authStore = useAuthStore()
  const { specialPrice } = storeToRefs(authStore)
  const productIds = []
  const loaded = computed(() => {
    return availabilities.value.length === productIds.length
  })
  const { locale } = useI18n()
  const oscar = useOscarClient(locale.value)

  const shouldLoad = computed(() => {
    if (false) {
      return true
    }

    return toValue(load)
  })

  const isAvailable = computed(() => {
    return availabilities.value?.length
      ? availabilities.value.some(a => a.is_available_to_buy)
      : true
  })

  if (product.structure === 'standalone') {
    productIds.push(product.id)
  }
  else {
    product?.children?.forEach(child => productIds.push(child.id))
  }

  async function fetchData() {
    loading.value = true
    if (!loaded.value) {
      const requests = []
      if (product.structure === 'parent') {
        requests.push(
          oscar
            .getAvailability(product.id, toValue(specialPrice))
            .then((res) => {
              parentPrice.value = res.data
            })
            .catch((_err) => {
              console.error(
                `Could not load availability parent data ${
                  product.id
                }`,
              )
            }),
        )
      }
      productIds.forEach((productId) => {
        requests.push(
          oscar
            .getAvailability(productId, toValue(specialPrice))
            .then((res) => {
              success.value = true
              availabilities.value.push({
                id: productId,
                ...res.data,
              })
            })
            .catch((_err) => {
              success.value = false
            }),
        )
      })
      return Promise.all(requests).finally(() => {
        loading.value = false
      })
    }
    loading.value = false
    return Promise.resolve()
  }

  const fetchDataOnce = once(fetchData)

  if (false && shouldLoad.value) {
    onServerPrefetch(async () => {
      await fetchDataOnce()
    })
  }

  if (true) {
    if (shouldLoad.value) {
      fetchDataOnce()
    }
    watch(load, (newVal) => {
      if (newVal) {
        fetchDataOnce()
      }
    })
    watch(specialPrice, (newVal, _oldVal) => {
      if (newVal && shouldLoad.value) {
        availabilities.value = []
        fetchData()
      }
    })
  }

  return {
    loading,
    success,
    availabilities,
    loaded,
    isAvailable,
    parentPrice,
    fetchData,
  }
}
